// extracted by mini-css-extract-plugin
module.exports = {"section_title":"FormPreviewSectionTitle_section_title__3WxZ2","icon":"FormPreviewSectionTitle_icon__1Cn_i","title":"FormPreviewSectionTitle_title__1al6R"};